import { useEffect } from "react";

export function useLogUnmount(log, name) {
  useEffect(() => {
    return () => {
      log.info(`destroying ${name}`);
    };
  }, [log, name]);
}
